<num-button data-cy="openMenu" type="blue" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu">
  {{ 'SHARED_COMPONENTS.MENU.OPTIONS' | translate }}
</num-button>

<mat-menu #menu="matMenu" yPosition="below" xPosition="before">
  <div *ngFor="let item of menuItems; let isLast = last" data-cy="{{ item.label | translate }}">
    <button
      [ngClass]="{ divider: !isLast, 'last-item': isLast }"
      mat-menu-item
      [disabled]="item.disabled"
      (click)="item.action(id)"
    >
      <fa-icon [icon]="item.icon" size="sm" class="icon-color"></fa-icon>
      {{ 'SHARED_COMPONENTS.MENU.' + item.label | translate }}
    </button>
  </div>
</mat-menu>
